import React from "react";
import {
  LightButton,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeaderWithTitleAndClose,
  PrimaryButton
} from "best-common-react";
import { inject, observer } from "mobx-react";

function ResetDigitalTicketsModal(props) {
  const { resetDigitalTicketsStore } = props.rootStore;

  return (
    <Modal
      show={resetDigitalTicketsStore.showResetTicketsModal}
      onClose={() => {}}
      size="lg"
      id="reset-digital-tickets-modal"
    >
      <ModalHeaderWithTitleAndClose
        title="Are you sure?"
        close={() => {
          resetDigitalTicketsStore.setShowResetTicketsModal(false);
        }}
      />
      <ModalBody>
        <p>
          Confirm that you want to reset the data on this request. This will clear out any ticket data associated with
          this request id.
        </p>
      </ModalBody>
      <ModalFooter>
        <div>
          <PrimaryButton
            onClick={() => {
              resetDigitalTicketsStore.resetTickets();
            }}
          >
            Reset Request
          </PrimaryButton>
          <LightButton
            onClick={() => {
              resetDigitalTicketsStore.setShowResetTicketsModal(false);
            }}
          >
            Cancel
          </LightButton>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default inject("rootStore")(observer(ResetDigitalTicketsModal));
